"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseWebSocket = exports.getWebSocketObservable = exports.jsonDeserializer = void 0;
const rxjs_1 = require("rxjs");
const webSocket_1 = require("rxjs/webSocket");
const HeartbeatWebSocket_1 = require("./HeartbeatWebSocket");
const trade_utils_lib_1 = require("trade_utils_lib");
const types_1 = require("./types");
function jsonDeserializer(e) {
    if (e.data) {
        try {
            return JSON.parse(e.data);
        }
        catch (e) {
            console.error(e);
        }
    }
    return undefined;
}
exports.jsonDeserializer = jsonDeserializer;
function getWebSocketObservable(url, data = undefined) {
    const wsConfig = {
        url: url,
        openObserver: {
            next: (event) => {
                if (data) {
                    const ws = event.target;
                    ws.send(JSON.stringify(data));
                }
            },
        },
        deserializer: jsonDeserializer,
    };
    return (0, webSocket_1.webSocket)(wsConfig);
}
exports.getWebSocketObservable = getWebSocketObservable;
class BaseWebSocket {
    constructor(config) {
        this.subject = new rxjs_1.Subject();
        this.connectionState = trade_utils_lib_1.State.UNKNOWN;
        this.errorMsg = "";
        this.firstConnectTime = 0;
        this.firstOpenTime = 0;
        this.lastCloseTime = 0;
        this.connectCount = 0;
        this.wsUrl = "";
        this.openObserver = {
            next: (event) => {
                console.log(`${this.wsUrl} open success`);
                this.webSocket = event.target;
                this.onOpen();
                this.connectionState = trade_utils_lib_1.State.DONE;
                this.errorMsg = "";
                if (this.firstOpenTime === 0) {
                    this.firstOpenTime = Date.now();
                }
                this.reportState();
                this.heartbeatWebSocket.onOpen();
            },
        };
        this.closeObserver = {
            next: (event) => {
                this.connectionState = trade_utils_lib_1.State.FAILED;
                this.errorMsg = `code:${event.code}, reason:${event.reason}, message:${event.message}`;
                this.lastCloseTime = Date.now();
                console.log(`${this.wsUrl} closed: ${this.errorMsg}`);
                this.reportState();
                this.heartbeatWebSocket.onClose();
            },
        };
        this.config = config;
        this.heartbeatWebSocket = new HeartbeatWebSocket_1.HeartbeatWebSocket((channel, param) => {
            var _a;
            const data = JSON.stringify({
                action: "heartbeat",
                channel,
                data: param,
            });
            (_a = this.webSocket) === null || _a === void 0 ? void 0 : _a.send(data);
        }, () => {
            this.close();
            this.open();
        });
    }
    createWebSocket(url) {
        this.wsUrl = url;
        const wsConfig = {
            url: url,
            openObserver: this.openObserver,
            closeObserver: this.closeObserver,
            deserializer: jsonDeserializer,
        };
        return (0, webSocket_1.webSocket)(wsConfig);
    }
    createDataObservable(type, onSubscribe) {
        return new rxjs_1.Observable((subscriber) => {
            if (onSubscribe) {
                onSubscribe(subscriber);
            }
            const subscription = this.subject.subscribe({
                next: (next) => {
                    const action = next;
                    if (type === types_1.DataType.all) {
                        subscriber.next(action.data);
                    }
                    else if (action.type === type) {
                        subscriber.next(action.data);
                    }
                },
                error: (err) => {
                    subscriber.error(err);
                },
            });
            // Observable结束的时候，同时 unsubscribe subscription
            subscriber.add(subscription);
        });
    }
    onOpen() { }
    close() {
        if (this.subscription) {
            console.log(`close websocket: ${this.wsUrl}`);
            this.subscription.unsubscribe();
            this.subscription = undefined;
            this.webSocket = undefined;
        }
    }
    getBaseStateMessage() {
        let message = "";
        message += `firstConnectTime: ${this.firstConnectTime}`;
        message += ` firstOpenTime: ${this.firstOpenTime}`;
        if (this.firstOpenTime > 0) {
            message += ` connect cost: ${this.firstOpenTime - this.firstConnectTime}`;
        }
        message += ` lastCloseTime: ${this.lastCloseTime}`;
        message += ` connectCount: ${this.connectCount}`;
        message += ` error: ${this.errorMsg}`;
        return message;
    }
}
exports.BaseWebSocket = BaseWebSocket;
